package one.devsbox.shared.ads

import one.devsbox.commons.EType

enum class DeviceType(override val mask: Int) : EType {
    INDOOR(2),
    OUTDOOR(4);

    companion object : EType.Finder<DeviceType>(entries)
}